module.exports = __webpack_public_path__ + "img/gi.6fb9581a.svg";